<template>
  <Notifications />
  <PublicLayout>
    <router-view />
  </PublicLayout>
</template>

<script>
import { Notifications } from "@estaly/ui";
import PublicLayout from "@/layouts/PublicLayout.vue";

export default {
  components: {
    Notifications,
    PublicLayout,
  },
};
</script>
